<template>
	<div class="page">
		<van-list :error.sync="error" error-text="请求失败，点击重新加载" v-model="loading" :finished="finished" finished-text="已加载完毕"
		 @load="loadData">
			<div @click="handleClick(item)" v-for="item in list" :key="item.id" class="item">
				<div class="title">2019年12月</div>
				<div class="content">
					<span>应发:￥9999</span>
					<span>实发:￥9999</span>
					<span>出勤天数:30</span>
					<span>社保:￥123</span>
					<span>公积金:￥123</span>
					<span>医疗保险:￥123</span>
					<span>生育保险:￥123</span>
					<span>补助:￥100</span>
				</div>
			</div>
		</van-list>
	</div>
</template>
<style scoped="scoped">
	.page {
		padding: 20px;
		box-sizing: border-box;
	}

	.item {
		width: 100%;
		max-width: 100%;
		min-height: 100px;
		position: relative;
		display: flex;
		flex-direction: column;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		border-radius: 3px;
		box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.28);
		box-sizing: border-box;
		padding: 6px 10px;
		margin-bottom: 10px;
	}

	.item .title {
		font-size: 18px;
	}

	.content {
		display: flex;
		font-size: 12px;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.content span {
		flex: 0 0 33%;
	}
</style>
<script>
	import {
		getList
	} from '@/api/gongzi.js'
	import nativeApi from '@/utils/native-bridge'

	export default {
		name: 'Gongzi',
		components: {},
		data() {
			return {
				query: {
					limit: 20,
					page: 0,
					type: 20
				},
				list: [],
				loading: false,
				finished: false,
				error: false
			}
		},
		methods: {
			handleClick(item) {
				// if (nativeApi.getRaxtoneClientInfo()) {
				// 	nativeApi.forwardPage({
				// 		uri: window.location.protocol + '//' + window.location.host + '/news?id=' + item.id
				// 	})
				// } else {
				// 	this.$router.push({
				// 		name: 'news',
				// 		query: {
				// 			id: item.id
				// 		}
				// 	})
				// }
			},
			loadData() {
				this.loading = true;
				const targetPage = this.query.page + 1;
				getList(Object.assign({}, this.query, {
					page: targetPage
				})).then(({
					data
				}) => {
					this.query.page = targetPage;
					if (data.items && data.items.length) {
						this.list = [{}]
						//this.list.concat(data.items)
						this.loading = false;
					} else {
						this.finished = true;
						this.loading = false;
					}
				}).catch((rep) => {
					this.error = true;
					this.loading = false;
				})
			}
		},
		created() {
			// this.loadData();
		}
	}
</script>
